<div *ngIf="data && data.length">
    <div
        *ngFor="let item of data; let last = last; let first = first"
        class="d-flex align-items-center gap-2 mb-3"
    >
        <div class="d-flex gap-3 align-items-center position-relative">
            <div>
                <div class="dot"></div>
                <div *ngIf="!last" class="line"></div>
            </div>
            <div>
                <div class="text-muted">{{ item.updatedUtc| date: 'HH:mm' }}</div>
                <div class="text-muted">{{ item.updatedUtc | date: 'dd/MM/yyyy' }}</div>
            </div>
            <div>
                <div *ngIf="first" style="font-size: 16px;" class="first">{{ item.status }}</div>
                <div *ngIf="!first" style="font-size: 16px;">{{ item.status }}</div>
                <div class="text-muted">{{ item.description }}</div>
            </div>
        </div>
    </div>
</div>